import Login from './Login';
import i18next from 'i18next';
import { authModules } from 'app/auth';
import enGB from '@locales/login/enGB';
import deAT from '@locales/login/deAT';

i18next.addResourceBundle('enGB', 'loginpage', enGB);
i18next.addResourceBundle('deAT', 'loginpage', deAT);

const LoginConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authModules.notloggedin,
	routes: [
		{
			path: 'login',
			element: <Login />
		}
	]
};

export default LoginConfig;
